import { render, staticRenderFns } from "./OrderReferenceView.vue?vue&type=template&id=d85d424e&"
import script from "./OrderReferenceView.vue?vue&type=script&lang=js&"
export * from "./OrderReferenceView.vue?vue&type=script&lang=js&"
import style0 from "./OrderReferenceView.vue?vue&type=style&index=0&id=d85d424e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports